import { render, staticRenderFns } from "./rejectedrequest.vue?vue&type=template&id=79925f4f"
import script from "./rejectedrequest.vue?vue&type=script&lang=js"
export * from "./rejectedrequest.vue?vue&type=script&lang=js"
import style0 from "./rejectedrequest.vue?vue&type=style&index=0&id=79925f4f&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports